const FilterFieldType = {
    TEXT: 0,
    NUMERIC: 1,
    DATE: 2,
    PERSON_LOOKUP: 3,
    RISK_LEVEL: 4,
    LOCATION_LOOKUP: 5,
    COURSE_LOOKUP: 6,
    COURSE_SECTION_LOOKUP: 7,
    PROGRAM_LOOKUP: 8,
    DEGREE_LOOKUP: 9,
    TAG_LOOKUP: 10,
    ACADEMIC_CALENDAR_LOOKUP: 11,
    HOLD_LOOKUP: 12,
    APPLICATION_STATUS: 13,
    DATE_AND_TIME: 14,
    ALERT_TYPE_LOOKUP: 15,
    NOTE_TYPE_LOOKUP: 16,
    SERVICE_DELIVERY_LOCATION_LOOKUP: 17,
    SERVICE_OFFERING_LOOKUP: 18,
    ATTENDANCE_STATUS_LOOKUP: 19,
    ACHIEVEMENT_TYPE_LOOKUP: 20,
    MESSAGE_PRIORITY_LOOKUP: 21,
    DELIVERY_METHOD_LOOKUP: 22,
    MESSAGE_DELIVERY_EXCEPTION_LOOKUP: 23,
    DELIVERY_STATUS_LOOKUP: 24,
    MESSAGE_TEMPLATE_LOOKUP: 25,
    MAJOR_LOOKUP: 26,
    BOOLEAN: 27,
    TRANSCRIPT_COURSE_STATUS_LOOKUP: 28,
    INTENT_LOOKUP: 29,
    ETHNICITY_LOOKUP: 30,
    RACE_LOOKUP: 31,
    ROLE_LOOKUP: 32,
    COURSE_SECTION_STATUS_LOOKUP: 33,
    ACADEMIC_TERM_LOOKUP: 34,
    TASK_STATUS_LOOKUP: 35,
    TASK_TEMPLATE_LOOKUP: 36,
    PERSON_APPLICATION_STATUS_LOOKUP: 37,
    MEETING_TYPE_LOOKUP: 38,
    TASK_PRIORITY_LOOKUP: 39,
    ACADEMIC_PLAN_STATUS_LOOKUP: 40,
    ACADEMIC_PLAN_TEMPLATE_LOOKUP: 41,
    RESOURCE_CATEGORY_LOOKUP: 42,
    STATE_LOOKUP: 43,
    RESOURCE_VISIBILITY_LOOKUP: 44,
    SURVEY_RESPONSE_STATUS_LOOKUP: 45,
    SURVEY_LOOKUP: 46,
    OUTREACH_LOOKUP: 47,
    GENDER_LOOKUP: 48,
    ENGAGEMENT_TYPE_LOOKUP: 49,
    VIRTUALIZED_APP_LOOKUP: 50,
    PERSON_TYPE_LOOKUP: 51,
    ACADEMIC_PLAN_TERM_STATUS: 52,
    AREA_OF_STUDY_LOOKUP: 53,
    AREA_OF_STUDY_MAJOR_LOOKUP: 54,
    MINOR_LOOKUP: 55,
    CONCENTRATIONS_LOOKUP: 56,
    ADMIT_STATUS_LOOKUP: 57,
    RESIDENCY_STATUS_LOOKUP: 58,
    STUDENT_LOAD_INTENT_LOOKUP: 59,
    HIGH_SCHOOL_GRADUATION_TYPE_LOOKUP: 60,
    HIGH_SCHOOL_TRANSCRIPT_STATUS_LOOKUP: 61,
    HIGH_SCHOOL_TRANSCRIPT_TYPE_LOOKUP: 62,
    STUDENT_TYPE_LOOKUP: 63,
    HIGH_SCHOOL_LOOKUP: 64,
    INSTITUTION_TRANSCRIPT_COURSE_STATUS_LOOKUP: 65,
    VETERAN_TYPE_LOOKUP: 66,
    TERM_ATTENDANCE_STATUS_LOOKUP: 67,
    FINANCIAL_AID_INDICATOR_LOOKUP: 68,
    PROSPECT_SOURCE_LOOKUP: 69,
    MEETING_STATUS_LOOKUP: 71,
    MEETING_MODALITY_LOOKUP: 72,
};
export default FilterFieldType;
